import { render } from "./dk-zz-otkl-view.vue?vue&type=template&id=139573b2"
import script from "./dk-zz-otkl-view.vue?vue&type=script&setup=true&lang=js"
export * from "./dk-zz-otkl-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-nsi/dk-zz-otkl-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "139573b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('139573b2', __exports__)) {
    api.reload('139573b2', __exports__)
  }
  
  module.hot.accept("./dk-zz-otkl-view.vue?vue&type=template&id=139573b2", () => {
    api.rerender('139573b2', render)
  })

}


export default __exports__